import React, { FC } from 'react';
import { Redirect } from 'react-router';

import { gql } from '@apollo/client';
import { useFlag } from '@modernloop/shared/feature-flag';

import {
  IntegrationConnectionStatus,
  useGetOrgRequiredOnboardingStatusQuery,
} from 'src/interviewer-portal/generated/graphql';
import LoadingScreen from 'src/shared/components/base/screenLoaders/LoadingScreen';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const GetOrgRequiredOnboardingStatus = gql`
  query GetOrgRequiredOnboardingStatus {
    thisOrg {
      id
      atsStatus
      directoryStatus
    }
  }
`;

const IPOrgIntegrationSetupGuard: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const newOnboardingExperience = useFlag('user_new_onboarding_experience');

  const { data, loading } = useGetOrgRequiredOnboardingStatusQuery({
    skip: !newOnboardingExperience,
  });
  if (newOnboardingExperience) {
    if (loading) {
      return <LoadingScreen />;
    }

    /**
     * Check for the ORG onboarded mandatory statuses
     */
    if (
      data?.thisOrg?.atsStatus === IntegrationConnectionStatus.NotConnected ||
      data?.thisOrg?.atsStatus === IntegrationConnectionStatus.Syncing ||
      data?.thisOrg?.directoryStatus === IntegrationConnectionStatus.NotConnected ||
      data?.thisOrg?.directoryStatus === IntegrationConnectionStatus.Syncing
    ) {
      return <Redirect to="/ip/onboarding" />;
    }
  }
  return <>{children}</>;
};

export default IPOrgIntegrationSetupGuard;
